import { getLocale } from "next-intl/server";
import { locales } from "@/i18n";
import { RequestCookies } from "next/dist/compiled/@edge-runtime/cookies";

export function safeParseAbsoluteUrl(url: string | undefined | null): URL | undefined {
  if (!url || typeof url !== "string") return undefined;
  try {
    const parsed = new URL(url);
    if (parsed.protocol && parsed.host) return parsed;
  } catch {
    // ignore
  }
  return undefined;
}

export const BASE_URL = safeParseAbsoluteUrl(process.env.COLLETTE_HOSTNAME)
  || new URL("http://localhost:3000");

export const unLocalizeUrlPath = (urlPath: string) => {
  if (!urlPath) return undefined;

  return `/${urlPath.split("/")
    .filter((part) => part && !locales.includes(part))
    .join("/")}`;
};

export const localizeUrlPath = async (urlPath: string) => (
  `/${await getLocale()}${unLocalizeUrlPath(urlPath) ?? ""}`
);

export const localizePath = (urlPath: string, cookies: RequestCookies) => (
  `/${cookies.get("NEXT_LOCALE")?.value}${unLocalizeUrlPath(urlPath) ?? ""}`
);

export const normalizeLocale = (locale: string | undefined): string => {
  if (!locale) return "en-US";
  const [lang, country] = locale.split("-");
  return `${lang}-${country?.toUpperCase() || ""}`;
};


export const normalizeHost = (host?: string | null): string | undefined => {
  if (!host) return undefined;
  const h = host.split(",")[0].trim().toLowerCase(); // proxies may comma-separate
  return h.replace(/:\d+$/, ""); // strip port
};

export const stripWww = (hostname: string): string => hostname.startsWith("www.") ? hostname.slice(4) : hostname;

export const stripTLD = (hostname: string): string => hostname.endsWith(".com") ? hostname.slice(0, -".com".length) : hostname;